import { Component, OnInit, Input, ChangeDetectionStrategy, Host } from "@angular/core";
import { SummaryConfig, QuestionKind } from "../../../../../common/models/flow.dto";
import { SummaryFlowViewComponent } from "../../summary-flow-view/summary-flow-view.component";
import { SummaryComponent } from '../../summary.component';

@Component({
    selector: "default-display",
    templateUrl: "./default-display.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DefaultDisplayComponent implements OnInit {
    @Input() isPreview: boolean;
    @Input() question: SummaryConfig;
    @Input() summary: SummaryFlowViewComponent;
    value: any;

    validArrayTypes: QuestionKind[] = [QuestionKind.MultiselectCheckbox, QuestionKind.ListEntry];

    constructor() { }

    ngOnInit() {
        this.value = this.getQuestionValue();
    }

    getFiles(): any {
        return this.summary.getFiles(this.question);
    }

    getQuestionValue(): string {

            let data: any = this.summary.getQuestionValue(this.question, this.question.contextValue);
            if (this.canDisplay(data)) {
                let value = data;
                if (data instanceof Array) {
                    value = data.join(", ");
                }
                return value;
            }
               
        return "";
    }

    setPage(): void {
        this.summary.flowComponent.reinstateSummaryNextButton();
        this.summary.flowComponent.setPage(this.question.sectionNumber, this.question.pageNumber);
    }

    private canDisplay(data: any): boolean {     
        if (data instanceof Array && this.validArrayTypes.findIndex(i => i === this.question.type) !== -1) return true;
        else if (data === undefined || data === null) return false;
        else if (typeof data === 'function' || typeof data == 'object') return false;
        return true;
    }

}
